import { jsx as d } from "react/jsx-runtime";
import { forwardRef as o } from "react";
import t from "@mui/material/Divider";
import m from "styled-components";
import { hexToRgba as v } from "../../theme/utils/styleUtils.js";
const a = {
  root: "dividerItemRoot",
  absolute: "dividerAbsolute",
  inset: "dividerInset",
  light: "dividerLight",
  middle: "dividerMiddle",
  vertical: "dividerVertical"
}, l = m(t).withConfig({
  displayName: "StyledDivider"
})([
  "&&.dividerItemRoot:before,&&.dividerItemRoot:after,&&.dividerItemRoot{border-color:",
  ";}&&.dividerItemRoot.dividerLight:before,&&.dividerItemRoot.dividerLight:after,&&.dividerItemRoot.dividerLight{border-color:",
  ";}"
], ({ theme: i }) => i.primaryBorder, ({ theme: i }) => v(i.primaryBorder, 0.5)), s = /* @__PURE__ */ o(({ classes: i, ...e }, r) => /* @__PURE__ */ d(l, {
  ...e,
  ref: r,
  classes: {
    ...a,
    ...i
  }
}));
s.displayName = "Divider";
export {
  s as default
};
